export default {
  categories: {
    shoes: "Buty",
    hoodies: "Bluzy/Swetry",
    tshirts: "Koszulki",
    jackets: "Kurtki",
    pants: "Spodnie/Szorty",
    headwear: "Nakrycia głowy",
    sets: "Zestawy",
    underwear: "Bielizna/Majtki",
    jersey: "Koszulki sportowe",
    accessories: "Akcesoria",
    bags: "Torby",
    belts: "Paski",
    perfumes: "Perfumy",
    other: "Inne rzeczy",
  },
};